"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var NewsletterModal = /*#__PURE__*/function (_window$AbstractBoots) {
    _inherits(NewsletterModal, _window$AbstractBoots);

    var _super = _createSuper(NewsletterModal);

    _createClass(NewsletterModal, null, [{
      key: "EXPIRE_DAYS",
      get: function get() {
        return 60;
      }
    }, {
      key: "NEWSLETTER_SHOWN_COOKIE",
      get: function get() {
        return 'newsletter-modal-shown';
      }
    }]);

    function NewsletterModal() {
      var _thisSuper, _this;

      _classCallCheck(this, NewsletterModal);

      _this = _super.call(this, "newsletter-modal", {
        $domElement: $("#newsletter-modal")
      });
      /*
      window.Cookies.remove(window.NewsletterModal.NEWSLETTER_SHOWN_COOKIE);
      window.Cookies.remove(window.NewsletterForm.NEWSLETTER_SUBSCRIBED_COOKIE);
      */

      if (!window.Cookies.get(window.NewsletterModal.NEWSLETTER_SHOWN_COOKIE) && !window.Cookies.get(window.NewsletterForm.NEWSLETTER_SUBSCRIBED_COOKIE)) {
        _this.visitedPages = 0;
        _this.$slideBG = _this.$domElement.find(".modal-body .slide img");
        $(document).on("turbolinks:load." + _this.id, function (event) {
          _this.visitedPages++;
          window.TweenMax.killDelayedCallsTo(_this.show);

          if (_this.state.match(window.AbstractBootstrapModal.SHOWN_STATE + '|' + window.AbstractBootstrapModal.SHOW_STATE)) {
            _this.hide();
          } else if (_this.visitedPages == 3) {
            window.TweenMax.delayedCall(6, _this.show, [], _assertThisInitialized(_this));
          }
        });
      }

      _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(NewsletterModal.prototype)), "addModules", _thisSuper).call(_thisSuper, [new window.NewsletterForm(_this.id + "_newsletter", {
        $domElement: _this.$domElement.find(".newsletter-form")
      })]);

      return _this;
    }

    _createClass(NewsletterModal, [{
      key: "show",
      value: function show() {
        if ($("body").find(".modal-backdrop").length) return;
        if (!this.$slideBG.hasClass("lazypreload")) this.$slideBG.addClass("lazyload lazypreload");

        _get(_getPrototypeOf(NewsletterModal.prototype), "show", this).call(this);
      }
    }, {
      key: "modalHideHandler",
      value: function modalHideHandler() {
        $(document).off("turbolinks:load." + this.id);
        window.TweenMax.killDelayedCallsTo(this.show);
        window.Cookies.set(window.NewsletterModal.NEWSLETTER_SHOWN_COOKIE, 'true', {
          expires: window.NewsletterModal.EXPIRE_DAYS
        });

        _get(_getPrototypeOf(NewsletterModal.prototype), "modalHideHandler", this).call(this);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        window.TweenMax.killDelayedCallsTo(this.show);
        $(document).off("turbolinks:load." + this.id);

        _get(_getPrototypeOf(NewsletterModal.prototype), "dispose", this).call(this);
      }
    }]);

    return NewsletterModal;
  }(window.AbstractBootstrapModal);

  window.NewsletterModal = NewsletterModal;
})(window);
